import { render, staticRenderFns } from "./filtrate.vue?vue&type=template&id=c1f18262&scoped=true"
import script from "./filtrate.vue?vue&type=script&lang=js"
export * from "./filtrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f18262",
  null
  
)

export default component.exports